import { AnimationType } from '@/models/games/BaseAnimation';
import { convertBJ2Hands } from '@/models/games/blackjack2/GameInfo';
import { animationSliceActions } from '@/modules/animation/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import {
    bj2HandSliceActions,
    getSeatHands,
} from '@/modules/rwdGame/blackjack2/slice/handSlice';
import { bj2SeatSliceActions } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import {
    convertDetailResultString,
    getMultiplierByMultiplierIndex,
} from '@/utils/games/carnivalTreasure';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { getHostByGameId } from '../../../modules/host/slice';
import store from '../../../store/store';
import {
    getBlackjackGameState,
    isWaitingCard,
    isWaitingDecision,
} from '../../../utils/games/blackjack';
import { parseDeckData } from '../../../utils/games/pokdeng';
import { BlackjackDecision, BlackjackResult } from '../../games/blackjack';
import {
    BlackjackDealtTurnState,
    BlackjackInitState,
} from '../../games/blackjack/states';
import { GameState } from '../../games/enums/GameState';
import { GameType as GameTypeEnum } from '../../games/enums/GameType';
import { PokDengResult } from '../../games/pokdeng';
import { CMDScGameState, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
// import { GameState as GameStateEnum } from '../../games/enums/GameState';
export class CMDScGameStateHandler extends AbstractHandler {
    _command: CMDScGameState;

    constructor(command: ICommand) {
        super();
        this._command = command as CMDScGameState;
    }
    commandDelay2() {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        const hostLiveData = getHostLiveDataByHostId(state, host.HostId);

        const gameState = getBlackjackGameState(hostLiveData.CurrentState);
        if (host.GameType == GameTypeEnum.Blackjack) {
            if (isWaitingCard(gameState) && this._command.ID != 0) {
                return host.GameDelay
                    ? host.GameDelay.countDownDelay - 1000
                    : 0;
            } else {
                return 0;
            }
        }
        return 0;
    }
    commandDelay() {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        const hostLiveData = getHostLiveDataByHostId(state, host.HostId);

        const gameState = getBlackjackGameState(hostLiveData.CurrentState);
        if (host.GameType == GameTypeEnum.Blackjack) {
            if (isWaitingCard(gameState) && this._command.ID != 0) {
                return host.GameDelay ? host.GameDelay.countDownDelay : 0;
            } else {
                return 0;
            }
        }
        return host.DelayDraw;
    }
    delayKey() {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        if (host.GameType == GameTypeEnum.Dragon) {
            return this._command.GameID.toString();
        }
        if (host.GameType == GameTypeEnum.PokDeng) {
            if (this._command.State == GameState.GameResult) {
                return this._command.GameID.toString();
            }
        }
        if (host.GameType == GameTypeEnum.Baccarat) {
            if (
                this._command.State >= GameState.Started &&
                this._command.State <= GameState.Shuffle
            ) {
                return this._command.GameID.toString();
            }
        }
        if (host.GameType == GameTypeEnum.Blackjack) {
            return this._command.GameID.toString();
        }
        if (host.GameType == GameTypeEnum.Blackjack2) {
            return this._command.GameID.toString();
        }
        return '';
    }
    forceRun() {
        return '';
    }
    // forceRun() {
    //     return this._command.GameID.toString();
    // }
    handle2(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        const hostLiveData = getHostLiveDataByHostId(state, host.HostId);
        const bjLastGameState = getBlackjackGameState(
            hostLiveData.CurrentState
        );

        batch(() => {
            switch (host.GameType) {
                case GameTypeEnum.Blackjack:
                    if (isWaitingDecision(bjLastGameState)) {
                        switch (this._command.ID) {
                            case BlackjackDecision.Split:
                                //TODO Decision success
                                break;
                            case BlackjackDecision.DoubleDown:
                                //TODO Decision success
                                break;
                            case BlackjackDecision.Surrender:
                                //TODO Decision success
                                break;
                        }

                        //Decision End
                        dispatch(
                            hostLiveSliceActions.updateCountDown({
                                hostId: host.HostId,
                                countDown: 0,
                                canLeave: false,
                            })
                        );
                    }
                    dispatch(
                        hostLiveSliceActions.updateGameResultObject({
                            hostId: host.HostId,
                            result: {
                                GameID: this._command.GameID,
                                GameCount:
                                    hostLiveData.CurrentResult?.GameCount,
                                Result: this._command.ID,
                                ResultString: this._command.ResultString,
                            } as BlackjackResult,
                        })
                    );
                    break;
            }
        });
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const gameState = this._command.State;
        const bjGameState = getBlackjackGameState(this._command.State);
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        const hostLiveData = getHostLiveDataByHostId(state, host.HostId);
        let isShuffing =
            host &&
            hostLiveData.CurrentState === GameState.Shuffle &&
            host.GameType !== GameTypeEnum.TeenPatti2020 &&
            host.GameType !== GameTypeEnum.AndarBahar;

        if (host && !isShuffing) {
            console.log(`hook::socket::run::${host.HostId}`, this._command);
            batch(() => {
                dispatch(
                    hostLiveSliceActions.updateGameState({
                        hostId: host.HostId,
                        state: gameState,
                    })
                );
                if (host.GameType === GameTypeEnum.Blackjack2) {
                    const Bj2Hand = getSeatHands(state, host.HostId);
                    if (Bj2Hand) {
                        const hands = convertBJ2Hands(
                            this._command.ResultString,
                            host.HostId
                        );
                        let tmp = 0;
                        const cur = hands.others.seats_info.find(
                            v => v.seat_num == hands.others.action_seat
                        );
                        if (cur) {
                            tmp += cur.h1.c.length + cur.h2.c.length;
                        }
                        const step = `${hands.others.state}${hands.others.action_seat}${hands.others.sub_state}${tmp}`;

                        if (Bj2Hand.ActionSeat !== hands.infos.ActionSeat) {
                            dispatch(
                                bj2HandSliceActions.updateCardsOnly({
                                    hostId: host.HostId,
                                    ...hands,
                                })
                            );
                            setTimeout(() => {
                                batch(() => {
                                    dispatch(
                                        bj2HandSliceActions.updateHands({
                                            hostId: host.HostId,
                                            ...hands,
                                        })
                                    );
                                    dispatch(
                                        bj2SeatSliceActions.updateDecisionStateStep(
                                            {
                                                hostId: host.HostId,
                                                step: step,
                                            }
                                        )
                                    );
                                });
                            }, 1000);
                        } else {
                            dispatch(
                                bj2HandSliceActions.updateHands({
                                    hostId: host.HostId,
                                    ...hands,
                                })
                            );
                            dispatch(
                                bj2SeatSliceActions.updateDecisionStateStep({
                                    hostId: host.HostId,
                                    step: step,
                                })
                            );
                        }
                    }
                }
                switch (host.GameType) {
                    case GameTypeEnum.Blackjack2:
                        //run in if case
                        break;
                    case GameTypeEnum.CarnivalTreasure:
                        dispatch(
                            hostLiveSliceActions.updateGameResult({
                                hostId: host.HostId,
                                result: 0,
                                resultString: this._command.ResultString,
                                resultReleased: false, //(gameState >= GameStateEnum.GameResult),
                            })
                        );
                        if (
                            gameState > GameState.Started &&
                            gameState < GameState.GameResult
                        ) {
                            const ctResult = convertDetailResultString(
                                this._command.ResultString
                            );
                            const mf = Number(ctResult.MultipliterFinal);
                            if (mf > 1) {
                                const mul = getMultiplierByMultiplierIndex(
                                    ctResult.Multipliters[
                                        ctResult.Multipliters.length - 1
                                    ]
                                ) as 2 | 10;
                                if (ctResult.MultiplierSize > 1) {
                                    dispatch(
                                        animationSliceActions.update({
                                            hostId: host.HostId,
                                            multiplier: mul,
                                            updatePayouts: ctResult.Odds,
                                        })
                                    );
                                } else {
                                    dispatch(
                                        animationSliceActions.init({
                                            hostId: host.HostId,
                                            multiplier: mul,
                                            init: ctResult.Odds,
                                        })
                                    );
                                }
                                dispatch(
                                    animationSliceActions.save({
                                        hostId: host.HostId,
                                        last: {
                                            animationType:
                                                AnimationType.CT_INIT,
                                            initialPayouts: ctResult.Odds,
                                        },
                                    })
                                );
                            }
                        }
                        break;
                    case GameTypeEnum.Roulette:
                    case GameTypeEnum.SeDie:
                        break;
                    case GameTypeEnum.Blackjack:
                        dispatch(
                            hostLiveSliceActions.updateGameResultObject({
                                hostId: host.HostId,
                                result: {
                                    GameID: this._command.GameID,
                                    GameCount:
                                        hostLiveData.CurrentResult?.GameCount,
                                    Result: this._command.ID,
                                    ResultString: this._command.ResultString,
                                } as BlackjackResult,
                            })
                        );
                        switch (bjGameState.subState) {
                            case BlackjackInitState.WaitSeatPlayerInsurance:
                                dispatch(
                                    hostLiveSliceActions.updateCountDown({
                                        hostId: host.HostId,
                                        countDown: host.GameDelay
                                            ? host.GameDelay.insurance
                                            : 0,
                                        canLeave: false,
                                    })
                                );
                                break;
                            case BlackjackDealtTurnState.WaitSideBetPlayerFollow:
                                dispatch(
                                    hostLiveSliceActions.updateCountDown({
                                        hostId: host.HostId,
                                        countDown: host.GameDelay
                                            ? host.GameDelay.followDecision
                                            : 0,
                                        canLeave: false,
                                    })
                                );
                                break;
                            default:
                                //Decision Start
                                if (isWaitingDecision(bjGameState)) {
                                    dispatch(
                                        hostLiveSliceActions.updateCountDown({
                                            hostId: host.HostId,
                                            countDown: host.GameDelay
                                                ? host.GameDelay.decision
                                                : 0,
                                            canLeave: false,
                                        })
                                    );
                                }
                                break;
                        }

                        break;
                    case GameTypeEnum.AndarBahar:
                        dispatch(
                            hostLiveSliceActions.updateGameResult({
                                hostId: host.HostId,
                                result: 0, //this._command.ID,
                                resultString: this._command.ResultString,
                                resultReleased: false,
                            })
                        );
                        break;
                    case GameTypeEnum.PokDeng:
                        if (gameState == GameState.GameResult) {
                            dispatch(
                                hostLiveSliceActions.updateGameResultObject({
                                    hostId: host.HostId,
                                    result: Object.assign({
                                        GameID: this._command.GameID,
                                        GameCount:
                                            hostLiveData.CurrentResult
                                                ?.GameCount,
                                        Result: 0, //this._command.ID,
                                        ResultString:
                                            this._command.ResultString,
                                        fullDeck: parseDeckData(
                                            this._command.ResultString
                                        ),
                                    } as PokDengResult),
                                })
                            );
                            dispatch(
                                hostLiveSliceActions.updatePokerShow({
                                    hostId: host.HostId,
                                    results: [],
                                })
                            );
                        } else {
                            dispatch(
                                hostLiveSliceActions.updateGameResult({
                                    hostId: host.HostId,
                                    result: 0, //this._command.ID,
                                    resultString: this._command.ResultString,
                                    resultReleased: false, //(gameState >= GameStateEnum.GameResult),
                                })
                            );
                        }
                        break;
                    case GameTypeEnum.Baccarat:
                        if ([3, 4, 5].indexOf(this._command.State) < 0) {
                            dispatch(
                                hostLiveSliceActions.updateGameResult({
                                    hostId: host.HostId,
                                    result: 0, //this._command.ID,
                                    resultString: this._command.ResultString,
                                    resultReleased: false, //(gameState >= GameStateEnum.GameResult),
                                })
                            );
                        }
                        break;
                    default:
                        dispatch(
                            hostLiveSliceActions.updateGameResult({
                                hostId: host.HostId,
                                result: 0, //this._command.ID,
                                resultString: this._command.ResultString,
                                resultReleased: false, //(gameState >= GameStateEnum.GameResult),
                            })
                        );
                        break;
                }
            });
        } else if (isShuffing) {
            console.warn('hook::socket::warning::state::after::shuffle');
        } else {
            console.warn(
                'hook::socket::warning::cannot::find::host',
                this._command.GameID
            );
        }
    }
}
